import { render, staticRenderFns } from "./SectorDetails.vue?vue&type=template&id=767ea22b&scoped=true&"
import script from "./SectorDetails.vue?vue&type=script&lang=js&"
export * from "./SectorDetails.vue?vue&type=script&lang=js&"
import style0 from "./SectorDetails.vue?vue&type=style&index=0&id=767ea22b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ea22b",
  null
  
)

export default component.exports